(function TripSummaryComponentMedia($, Adzuki)
{
	'use strict';

	const component = {
		inject: [
			'getFaIconStyle',
		],
		props: {
			componentId: {
				type    : Number,
				required: false,
			},
			currentImages: {
				type    : Array,
				default : [],
				required: false,
			},
			currentHotelImages: {
				type    : Array,
				default : [],
				required: false,
			},
			fitBuilderId: {
				type    : Number,
				required: false,
			},
			formId: {
				type    : String,
				required: true,
			},
			formName: {
				type    : String,
				required: true,
			},
		},
		template: '#ts-component-media',
		data() {
			return {
				baseUri               : Adzuki.base_uri,
				images                : this.currentImages,
				locationResults       : [],
				selectedLocationImages: [],
				hotelImagesResults    : this.currentHotelImages,
				selectedHotelImages   : [],
				locationSearchDisabled: false,
				fetchingLocationImages: false,
				showMaxxMediaModal    : false,
				showPlayVideoModal    : false,
				playVideoHtml         : '',
				currentVideo          : null,

				// alerts inside of the Media Hub
				showAlert   : false,
				alertTitle  : null,
				alertMessage: null,
				alertType   : null,
			};
		},
		watch: {
			currentImages(newImages) {
				this.images = newImages;
			},
			currentHotelImages(newHotelImages) {
				this.hotelImagesResults = newHotelImages;
			},
		},
		methods: {
			async addImageFromLibrary() {
				const modal   = new bootstrap.Modal('#modalWindow');
				const modalEl = $('#modalWindow');

				modalEl.addClass('wide');
				modalEl.find('.modal-title').text('Component image library');
				modalEl.find('.modal-body').text('Loading component image library...');

				try {
					modal.show();

					const html = await Adzuki.Ajax.get('/TripSummaryPictureLibrary/imageSearch');

					modalEl.find('.modal-body').html(html);

					Adzuki.Form.initAjaxForm('ImageLibrarySearch');

					modalEl.find('.ts-add-selected-pictures').first().off().on('click', (e) => {
						e.preventDefault();

						const selectedImages = modalEl.find('.item-checkboxes:checked');
						const imageIds       = [];

						if (selectedImages.length === 0) {
							return Adzuki.StatusMessage('error', 'No images selected');
						}

						selectedImages.each((i, img) => {
							const id = parseInt($(img).val());

							imageIds.push(id);
						});

						this.addImagesFromLibrary(imageIds);

						modal.hide();
					});

					modalEl.on('hidden.bs.modal', function _restoreModal() {
						modalEl.removeClass('wide').off('hidden.bs.modal');
						modalEl.find('.modal-body').html();
					});
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error loading component image library: ${error.message}`);
				}
			},
			async addImagesFromLibrary(imageIds) {
				const response = await Adzuki.Ajax.post('/TripSummaryPictureLibrary/getImages', {
					image_ids: imageIds,
				});

				if (response.error) {
					return Adzuki.StatusMessage('error', `Error getting images from the library: ${response.error}`);
				}

				const images = response;

				for (const image of images) {
					this.images.push(image);
				}
			},
			addImageFromMaxxMedia() {
				this.showMaxxMediaModal = true;
			},
			closeMaxxMediaModal() {
				this.showMaxxMediaModal = false;
			},
			closePlayVideoModal() {
				this.showPlayVideoModal = false;
				this.currentVideo       = null;
				this.playVideoHtml      = '';
			},
			componentImage(image) {
				if (typeof image.id === 'string' && image.id.startsWith('google_')) {
					return this.baseUri + '/Searches/googleImageConvert/' + image.image;
				}

				if (typeof image.id === 'string' && image.id.startsWith('viator_')) {
					return image.image;
				}

				// a Maxx Media file stored only on S3 has no local path (MEDIA-309)
				if (image.preview_url) {
					return '\'' + image.preview_url + '\'';
				}

				return '\'' + this.baseUri + '/' + image.image_path + encodeURIComponent(image.filename) + '\'';
			},
			deleteImage(image) {
				let url         = '';
				let componentId = '';
				const mediaType = image.video ? 'video' : 'image';

				if (this.fitBuilderId) {
					url         = '/TripSummaries/';
					componentId = image.fit_builder_component_id;
				} else {
					url         = '/TripSummaryComponents/';
					componentId = image.fit_builder_component_library_id;
				}

				url += 'deleteComponentImage/';
				url += componentId + '/';
				url += image.id;

				this.hideTooltips();

				// name the component, as the card's picture delete does; the title is a
				// plain form input, not Vue state, and is escaped because the confirm renders HTML
				const componentTitle = $.trim($('#' + this.formId + 'title').val() || '');
				const content        = componentTitle
					? `It will be removed from “${Adzuki.CustomConfirm.escape(componentTitle)}”. This can't be undone.`
					: 'It will be removed from this component. This can\'t be undone.';

				Adzuki.CustomConfirm.destructive({
					title           : `Delete this ${mediaType}?`,
					content         : content,
					confirm_btn_text: `Delete ${mediaType}`,
					confirm         : async () => {
						// this image was added from the library, or from a supplier, no need to send request to server
						if (
							typeof image.id === 'string'
							&& (
								image.id.startsWith('library_') ||
								image.id.startsWith('aip_') ||
								image.id.startsWith('google_') ||
								image.id.startsWith('viator_') ||
								image.id.startsWith('mediahub_')
							)
						) {
							this.images = this.images.filter(img => img.id !== image.id);

							return;
						}

						try {
							const response = await Adzuki.Ajax.get(url);

							if (response.error) {
								return Adzuki.StatusMessage('error', `Error deleting ${mediaType}: ${response.error}`);
							}

							this.images = this.images.filter(img => img.id !== image.id);
						} catch (error) {
							return Adzuki.StatusMessage('error', `Error deleting ${mediaType}: ${error.message}`);
						}
					}
				});
			},
			hideTooltips() {
				$('[data-toggle="tooltip"]').tooltip('hide');
			},
			// NOTE: the hotel photo picker (its state, the auto-select, and the
			// select/format helpers below) now lives in the lodging form and renders
			// on the General Info tab. The handlers here are no longer wired to any
			// template in this component — kept only to avoid touching a component
			// shared by every component type.
			hotelImageBgUrl(image) {
				// handle giata images
				if (image.large) {
					return image.large;
				}

				if (image.photo_url) {
					return image.photo_url;
				}

				// this is an all-inclusive property image
				if (image.filename) {
					return this.baseUri + '/' + image.image_path + encodeURIComponent(image.filename);
				}

				return null;
			},
			hotelImageFormKey(image, index) {
				let formKey = this.formName;

				if (image.large || image.photo_url) {
					// this is a giata image
					formKey += '[hotel_images][' + index + ']';
				} else if (image.filename) {
					// this is a property image
					formKey += '[aip_images][' + (index + 1) + '][id]';
				}

				return formKey;
			},
			hotelImageFormValue(image) {
				// handle giata images
				if (image.large) {
					return image.large;
				}

				if (image.photo_url) {
					return image.photo_url;
				}

				// this is an all-inclusive property image
				if (image.filename) {
					return 'aip_' + image.id;
				}

				return null;
			},
			hotelImageIsSelected(image) {
				return this.selectedHotelImages.find(i => i.id === image.id);
			},
			playVideo(image) {
				this.showPlayVideoModal = true;
				this.currentVideo       = image;
				let videoSrc            = null;

				if (typeof image.id === 'string' && image.id.startsWith('mediahub_')) {
					videoSrc = image.video;
				} else {
					videoSrc = this.baseUri + '/' + image.image_path + encodeURIComponent(image.video);
				}

				this.playVideoHtml = '<div class="text-center"><video controls width="840" height="480" playsinline autoplay muted><source src="' + videoSrc + '" type="video/mp4">Your browser does not support the video tag.</video></div>';
			},
			resetLocationSearch() {
				this.locationSearchDisabled = false;
				this.locationResults        = [];
				this.selectedLocationImages = [];

				this.$refs.locationSearchInput.value = '';
			},
			selectHotelImage(image) {
				if (this.selectedLocationImages.length >= 10) {
					return Adzuki.StatusMessage('error', 'You can only select up to 10 images');
				}

				const found = this.selectedHotelImages.find(i => i.id === image.id);

				if (found) {
					this.selectedHotelImages = this.selectedHotelImages.filter(i => i.id !== image.id);
				} else {
					this.selectedHotelImages.push(image);
				}
			},
			selectLocationImage(image) {
				if (this.selectedLocationImages.length >= 10) {
					return Adzuki.StatusMessage('error', 'You can only select up to 10 images');
				}

				if (this.selectedLocationImages.includes(image)) {
					this.selectedLocationImages = this.selectedLocationImages.filter(i => i !== image);
				} else {
					this.selectedLocationImages.push(image);
				}
			},
			async selectMedia(media) {
				if (!media.media_id) {
					return;
				}

				const mediaIds = [];

				if (Array.isArray(media.media_id)) {
					mediaIds.push(...media.media_id);
				} else {
					mediaIds.push(media.media_id);
				}

				try {
					const response = await Adzuki.Ajax.post('/Media/getMediaItemsById', {
						media_ids: JSON.stringify(mediaIds)
					});

					if (response.status === 'error') {
						return Adzuki.StatusMessage('error', `Error getting media items: ${response.message}`);
					}

					const mediaItems = response;

					for (const mediaItem of mediaItems) {
						const image = {
							id        : 'mediahub_' + mediaItem.id,
							image_path: mediaItem.path,
							filename  : mediaItem.original_file_name,
							type      : mediaItem.type,
						};

						// use thumbnail image for videos
						if (image.type === 'video') {
							image.video      = mediaItem.remote_url;
							image.image_path = mediaItem.thumbnail_image;
							image.filename   = '';

							if ((/^https?:\/\//).test(mediaItem.thumbnail_image || '')) {
								image.preview_url = mediaItem.thumbnail_image;
							}
						} else if (!mediaItem.path && mediaItem.remote_url) {
							// S3-only upload (no local asset), preview it from the bucket (MEDIA-309)
							image.preview_url = mediaItem.remote_url;
						}

						this.images.push(image);
					}
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error getting media items: ${error.message}`);
				}
			},
			async setMainImage(image) {
				let url         = '';
				let componentId = '';

				// this image was added from the library or from a supplier, no need to send request to server
				if (
					typeof image.id === 'string'
					&& (
						image.id.startsWith('library_') ||
						image.id.startsWith('aip_') ||
						image.id.startsWith('google_') ||
						image.id.startsWith('viator_') ||
						image.id.startsWith('mediahub_')
					)
				) {
					this.hideTooltips();

					this.images = this.images.map(img => {
						img.main_image = false;

						if (img.id === image.id) {
							img.main_image = true;
						}

						return img;
					});

					return;
				}

				if (this.fitBuilderId) {
					url         = '/TripSummaries/';
					componentId = image.fit_builder_component_id;
				} else {
					url         = '/TripSummaryComponents/';
					componentId = image.fit_builder_component_library_id;
				}

				url += 'setComponentMainImage/';
				url += componentId + '/';
				url += image.id;

				try {
					const response = await Adzuki.Ajax.get(url);

					if (response.error) {
						return Adzuki.StatusMessage('error', `Error setting main image: ${response.error}`);
					}

					this.hideTooltips();

					this.images = this.images.map(img => {
						img.main_image = false;

						if (img.id === image.id) {
							img.main_image = true;
						}

						return img;
					});
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error setting main image: ${error.message}`);
				}
			},
		},
		mounted() {
			// location typeahead
			Adzuki.Typeahead(
				this.$refs.locationSearchInput,
				'/Searches/googleAutocomplete/',
				async (item, $self, typeahead) => {
					this.fetchingLocationImages = true;

					try {
						const url      = '/Searches/googlePlace/' + item.id + '/1';
						const response = await Adzuki.Ajax.get(url);

						if (response.error) {
							return Adzuki.StatusMessage('error', `Error getting location details: ${response.error}`);
						}

						if (!response || response.length === 0) {
							return Adzuki.StatusMessage('error', 'No images found');
						}

						this.locationResults        = response;
						this.locationSearchDisabled = true;
					} catch (error) {
						return Adzuki.StatusMessage('error', `Error getting place details: ${error.message}`);
					} finally {
						this.fetchingLocationImages = false;
					}
				},
				function template(item) {
					return item.name;
				}
			);
		},
	};

	Adzuki.VueComponents.TripSummaryComponentMedia = component;
}(jQuery, window.Adzuki || {}));
